<template>
  <div class="breadcrumbs">
    <template v-if="breadcrumbs.backButton">
      <BaseButtonIcon
        v-if="breadcrumbs.backButton.isNativeBack"
        size="large"
        :title="$t('buttons.BACK_BUTTON_TITLE')"
        :aria-label="$t('buttons.BACK_BUTTON_TITLE')"
        @click="nativeBack()"
      >
        <ArrowIcon />
      </BaseButtonIcon>

      <router-link
        v-else
        :to="{
          name: breadcrumbs.backButton.name,
          params: breadcrumbs.backButton.params,
        }"
        name=""
        :title="$t('buttons.BACK_BUTTON_TITLE')"
        :aria-label="$t('buttons.BACK_BUTTON_TITLE')"
      >
        <BaseButtonIcon tabindex="-1" size="large">
          <ArrowIcon />
        </BaseButtonIcon>
      </router-link>
    </template>

    <h1 class="label">
      <div class="label__title">
        {{ breadcrumbs.title }}
      </div>
      <div v-if="breadcrumbs.subtitle" class="label__subtitle">
        {{ breadcrumbs.subtitle }}
      </div>
    </h1>

    <UserSyncStatus v-if="shouldShowSyncStatus" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseButtonIcon from '@/components/generics/base/BaseButtonIcon.vue'
import ArrowIcon from '@/components/icon_components/ArrowIcon.vue'
import UserSyncStatus from '@/components/user/UserSyncStatus.vue'
import { useCanUploadUsers } from '@/components/user/upload/useCanUploadUsers'
import { useBreadcrumbs } from './useBreadcrumbs'

const breadcrumbs = useBreadcrumbs()
const { canUploadUsers } = useCanUploadUsers()

const shouldShowSyncStatus = computed(
  () => breadcrumbs.value.showUserSync && canUploadUsers.value
)

const nativeBack = () => {
  window.history.back()
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $spacing-3xs;
}

.label {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: $spacing-4xs;

  &__title {
    @include subtitle;
    font-size: $font-size-2xl;
    line-height: 1;
  }

  &__subtitle {
    @include subtitle-2;
    line-height: 18px;
    color: $color-text-light;
  }
}

@media screen and (max-width: $tablet-width-max) {
  .label {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
  .label__title {
    font-size: $font-size-xl;
  }
  .label__subtitle {
    font-size: $font-size-s;
  }
}
</style>
